import { useEffect, useState } from "react";
import { SectionTitle } from "./Heading";
import { fetchInterests, removeInterest, type Interests } from "../lib/offerAdds";

/**
 * Offer interests on Settings: the brands added from the Offers page (Add on
 * next run's "also treat future offers as worth adding"), each removable here.
 * The file's brands only a deploy changes, so they are counted, not listed.
 */
export function OfferInterests() {
  const [data, setData] = useState<Interests | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [removing, setRemoving] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    fetchInterests().then(
      (d) => { if (active) setData(d); },
      (e: unknown) => { if (active) setError(e instanceof Error ? e.message : String(e)); },
    );
    return () => { active = false; };
  }, []);

  const remove = (merchant: string) => {
    setRemoving(merchant);
    setError(null);
    removeInterest(merchant)
      .then(() => {
        setData((d) => d && { ...d, added: d.added.filter((a) => a.merchant !== merchant) });
      })
      .catch((e: unknown) => { setError(e instanceof Error ? e.message : String(e)); })
      .finally(() => { setRemoving(null); });
  };

  return (
    <section className="space-y-2">
      <SectionTitle>Offer interests</SectionTitle>
      {data && (data.added.length === 0 ? (
        <p className="text-sm text-neutral-400">No brands added from the Offers page yet.</p>
      ) : (
        <ul className="divide-y divide-neutral-800 rounded-xl bg-neutral-900">
          {data.added.map((a) => (
            <li key={a.merchant} className="flex items-center gap-3 px-4 py-2">
              <span className="min-w-0 grow truncate text-sm">{a.merchant}</span>
              <button
                type="button"
                disabled={removing === a.merchant}
                onClick={() => { remove(a.merchant); }}
                aria-label={`Remove ${a.merchant}`}
                className="btn btn-ghost btn-sm shrink-0"
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      ))}
      {data && data.file.length > 0 && (
        <p className="text-xs text-neutral-500">
          {data.file.length} more come from <code>offer_interests.yaml</code>, which changes with a deploy.
        </p>
      )}
      {error && <p role="alert" className="text-sm text-red-300">{error}</p>}
    </section>
  );
}
